// extracted by mini-css-extract-plugin
module.exports = {"segment":"styles_segment__1ig0L","title":"styles_title__2kdc7","content":"styles_content__1Rt27","spin":"styles_spin__33Hj5"};